<template>
    <base-button-flat
        @click="addToCart"
        :variant="buttonVariant"
        :is-disabled="!canAdd"
        class="rounded-none lg:rounded-sm h-12 lg:h-16 w-full text-sm sm:text-base tracking-widest md:leading-4"
    >
        {{ canAdd ? `${$t('ADD_TO_CART')} - ${price}` : $t('NOTIFY_ME') }}
    </base-button-flat>
</template>

<script>
    import allStores from '../stores/all';

    import BaseButtonFlat from './BaseButtonFlat.vue';

    // Formats the price according to current locale settings.
    function formatPrice(v, relative, locale, currency) {
        if (v == null || v === '' || v === 0) {
            return '';
        }

        const resolveCurrency = currency ?? 'USD';

        const wholeFormatter = Intl.NumberFormat(locale ?? 'en-US', {
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            notation: 'standard',
            currency: resolveCurrency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        const fractionFormatter = Intl.NumberFormat(locale ?? 'en-US', {
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            notation: 'standard',
            currency: resolveCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        const formatted = v % 1 === 0 ? wholeFormatter.format(v) : fractionFormatter.format(v);

        if (relative) {
            if (formatted.startsWith('-')) {
                return formatted;
            }

            return `+${formatted}`;
        }

        return formatted;
    }

    export default {
        mixins: [allStores],

        components: {
            BaseButtonFlat,
        },

        props: {
            updateMode: Boolean,
        },

        computed: {
            userMadeSelection() {
                return this.customizerStore.userMadeSelection;
            },

            selectionsComplete() {
                return this.customizerStore.selectionsComplete;
            },

            hasBackorderedSize() {
                return this.customizerStore.hasBackorderedSize;
            },

            buttonVariant() {
                return this.selectionsComplete && !this.hasBackorderedSize ? 'primary' : 'primaryDisabled';
            },

            canAdd() {
                if (this.customizerStore.orderableBase == null) {
                    return false;
                }

                if (this.customizerStore.cartItems == null) {
                    return true;
                }

                // eslint-disable-next-line no-restricted-syntax
                for (const item of Object.values(this.customizerStore.cartItems)) {
                    if (item.ats == null) {
                        return false;
                    }

                    if (item.need > item.ats) {
                        return false;
                    }
                }

                return true;
            },

            price() {
                let price = 0;

                if (this.customizerStore.cartItems != null) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const item of Object.values(this.customizerStore.cartItems)) {
                        price += item.price * item.need;
                    }
                }

                return formatPrice(price, false, 'en-US', 'USD');
            },
        },

        methods: {
            addToCart() {
                if (this.selectionsComplete && !this.hasBackorderedSize) {
                    this.customizerStore.setCartErrors(0);
                    this.customizerStore.setErrorState(false);

                    this.customizerStore.addToCartAndExit();
                } else {
                    this.customizerStore.setHasBackorderedError();
                    this.customizerStore.setCartErrors(1);
                    this.customizerStore.setErrorState(true);
                }
            },
        },
    };
</script>
